export const CONTAINER_TEMPLATES = [
  {
    id: "1col",
    label: "1 Column",
    columns: 1
  },
  {
    id: "2col",
    label: "2 Columns",
    columns: 2,
    
  },
  {
    id: "3col",
    label: "3 Columns",
    columns: 3
  },
];
